{
  "version": 1,
  "asset_id": "31c9909b-c087-42b8-b1f3-1e62567a2ffa",
  "project_id": "288ffafd-b4ec-4687-a58e-f3a6c56e4541",
  "url": "/__l5e/assets-v1/31c9909b-c087-42b8-b1f3-1e62567a2ffa/home-video-2.mp4",
  "r2_key": "a/v1/288ffafd-b4ec-4687-a58e-f3a6c56e4541/31c9909b-c087-42b8-b1f3-1e62567a2ffa/home-video-2.mp4",
  "original_filename": "home-video-2.mp4",
  "size": 2041042,
  "content_type": "video/mp4",
  "created_at": "2026-08-31T21:19:17Z"
}
